import { GlButton } from '@gitlab/ui';
export default {
    name: 'ResolveDiscussionButton',
    components: {
        GlButton
    },
    props: {
        isResolving: {
            type: Boolean,
            required: false,
            default: false
        },
        buttonTitle: {
            type: String,
            required: true
        }
    },
    emits: [
        'on-click'
    ]
};
